<template>
  <div class="gj-add-title">
    <div class="chunk"></div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "app-add-title",
  }
</script>

<style scoped>
  .gj-add-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
  .chunk{
    height: 14px;
    width: 4px;
    background: #1F6EEF;
    margin-right: 10px;
  }
</style>
